import InactiveUsersList from './InactiveUsersList';
export default InactiveUsersList;
